var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 17",
    fill: "#DC3545",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23404 16.862L15.523 5.188H11.47L14.064 0H9.22304L7.06104 9.08H10.238L8.23404 16.862Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.156 10.309L3.931 9.03198L0 9.70798L0.225 10.985L4.156 10.309Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9819 6.55394L18.2069 7.83093L22.1369 7.15494L21.9119 5.87793L17.9819 6.55394Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56583 11.436L1.15283 13.382L1.80183 14.505L5.21483 12.5591L4.56583 11.436Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9849 3.48093L20.3358 2.35693L16.9229 4.30293L17.5719 5.42693L20.9849 3.48093Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21483 4.30293L1.80183 2.35693L1.15283 3.48093L4.56583 5.42693L5.21483 4.30293Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9849 13.382L17.5719 11.436L16.9229 12.5601L20.3358 14.506L20.9849 13.382Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.156 6.55394L0.226 5.87793L0 7.15494L3.93 7.83093L4.156 6.55394Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9819 10.309L21.9119 10.985L22.1369 9.70798L18.2069 9.03198L17.9819 10.309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/low-battery.951e2861f50121c340c2767ea0555ffc.svg";
export { ForwardRef as ReactComponent };